"use client";
/**
 * The router every door drawn in the Dock reaches for (contract 2026-09-23):
 * in the shell's Dock window a push goes to the MAIN window (forwardRoute),
 * which the shell raises, and the panel never leaves /dock. Everywhere else
 * it is next's own push, decided at the moment of the push.
 */
import { useMemo } from "react";
import { useRouter } from "next/navigation";
import { forwardRoute } from "@/lib/dock-window";

export function useDockRouter(): { push: (route: string) => void } {
  const router = useRouter();
  return useMemo(
    () => ({
      push: (route: string) => {
        if (!forwardRoute(route)) router.push(route);
      },
    }),
    [router]
  );
}
